import ReactGA4 from 'react-ga4';
import { debug } from '@/config';
import Cookies from 'universal-cookie';
import { CookiePreferenceCategory, CookiePreferences } from '@tikkie/blokkie';
import {
  ANALYTICAL_PREFERENCE,
  FUNCTIONAL_PREFERENCE,
  PERSONAL_PREFERENCE,
} from '@/components/cookie-banner/use-tikkie-cookies';

export const getConsent = (cookiePreferences: CookiePreferences) => {
  const getConsentStatus = (category: CookiePreferenceCategory) =>
    cookiePreferences.find((cookie) => cookie.type === category)?.enabled
      ? 'granted'
      : 'denied';

  const analyticalEnabled = getConsentStatus(
    CookiePreferenceCategory.ANALYTICAL
  );
  const personalEnabled = getConsentStatus(CookiePreferenceCategory.PERSONAL);
  const functionalEnabled = getConsentStatus(
    CookiePreferenceCategory.FUNCTIONAL
  );

  return {
    ad_personalization: personalEnabled, // Personalised Cookies
    ad_storage: personalEnabled, // Personalised cookies
    ad_user_data: personalEnabled, // Personalised Cookies
    analytics_storage: analyticalEnabled, // Analytical Cookies
    functionality_storage: functionalEnabled, // Functional Cookies
    personalization_storage: personalEnabled, // Personalised Cookies
    security_storage: functionalEnabled, // Functional Cookies
  };
};

export function initializeAnalyticsProvider() {
  const measurementId = import.meta.env
    .VITE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;

  if (!measurementId) {
    throw new Error('Google Analytics Measurement ID is not defined');
  }

  if (debug) {
    console.log(
      'Initializing Google Analytics 4 with Measurement ID:',
      measurementId
    );
  }

  const cookies = new Cookies().getAll();
  const consent = getConsent([
    FUNCTIONAL_PREFERENCE,
    ANALYTICAL_PREFERENCE,
    {
      ...PERSONAL_PREFERENCE,
      enabled: cookies.cookieSocial === true && cookies.cookieTarget === true,
    },
  ]);
  ReactGA4.gtag('consent', 'default', consent);

  ReactGA4.initialize(measurementId);
}

export const updateAnalyticsConsent = (consentBody: Record<string, string>) => {
  ReactGA4.gtag('consent', 'update', consentBody);
};

export const analyticsPageview = (page: string) => {
  ReactGA4.send({
    hitType: 'pageview',
    page,
  });
};

export const analyticsEvent = (name: string, category: string, rest?: object) =>
  ReactGA4.event(name, {
    category,
    ...rest,
  });
